import { Form, Input } from "antd";
import { noTrailingSpaceAllowedRule } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

export const ATSIdField = ({
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <Input placeholder="Enter ATS ID" disabled={disabled} style={style} />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="ATS ID"
        name="extAtsId"
        rules={[noTrailingSpaceAllowedRule()]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="ATS ID" required={false} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
